// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsAttributionFactorAnalysisAppModule } from './app.module';
bootstrapAppModule(MutualFundsAttributionFactorAnalysisAppModule);
